export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";